import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GRAY_DARK, WHITE } from '../../../theme/colors'

export const Container = styled.div`
  height: 100%;
  font-family: "Avenir Next";
  #header {
    padding: 6px 20px;
    #title {
      font-size: 20px;
      span {
        margin-left: 6px;
        color: red;
        font-size: 12px;
        font-weight: 600;
      }
    }
    #title.guest {
      text-align: center;
    }
    p {
      font-size: 12px;
    }
  }
  #promptContainer {
    margin-inline: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    textarea {
      color: #000;
      width: 100%;
      border: 1px solid black;
      font-size: 12px;
      padding: 8px;
      &::placeholder {
        color: #606060;
        opacity: 0.7;
      }
    }
    .char-count {
      font-size: 0.8em;
      color: #666;
      margin-top: 5px;
    }
    .limit-reached {
      color: red;
      font-weight: bold;
    }
    button {
      flex-basis: 24%;
      padding-inline: 12px;
      font-size: 14px;
      font-weight: 500;   
      color: white;
      background-color: black;
      border-radius: 24px;
      height: 44px;
      cursor: pointer;
      &:disabled {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.3;
        cursor: not-allowed;
      }
      .generate-spin {
        margin-right: 6px;
      }
    }
  }
  #output {
    display: flex;
    margin: 20px;
  }
  #favoriteContainer {
    margin: 20px;
    h6 {
      font-size: 14px;
      i {
        margin-left: 6px;
        color: red;
      }
    }
  }
  #favorite {
    display: flex;
    flex-wrap: wrap;
    max-height: 360px;
    overflow-y: scroll;
    padding: 6px;
    &.border {
      border: 1px solid black;
    }
    div {
      margin-right: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 90px;
      }
      button {
        width: fit-content;
        margin-block: 4px;
        background-color: white;
        border-radius: 24px;
        border: 1px solid black;
        padding-inline: 11px;
        cursor: pointer;
      }
      button.apply {
        color: white;
        background-color: black;
      }
    }
    div:last-child {
      margin-right: unset;
    }
  }
  #limitReached {
    padding: 15px;
    margin-inline: 20px;
    border-radius: 5px;
    border: 1px solid transparent;
    background-color: #f8d7da;
    color: #721c24;
    border-color: #f5c6cb;
    font-size: 0.9em;
  }
`

export const ImageCard = styled.div`
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    width: fit-content;
    margin-block: 12px;
    padding-inline: 12px;
    font-size: 12px;
    font-weight: 400;   
    color: white;
    background-color: black;
    border-radius: 16px;
    height: 26px;
    cursor: pointer;
  }
  div:last-child {
    margin-right: unset;
  }
  button.favorite-button {
    width: fit-content;
    margin-block: -8px;
    margin-inline: 2px;
    font-size: 12px;  
    color: white;
    background-color: red;
    border: transparent;
    border-radius: 16px;
    height: 26px;
    cursor: pointer;
    i {
      margin-inline: 8px;
    }
  }
  button.favorite-button.favorited {
    background-color: white;
    border: 1px solid red;
    i {
      color: red;
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  img.ai-generated {
    width: 90px;
    height: 90px;
  }
`

export const ZoomIconContainer = styled.img`
  position: absolute;
  top: 4px;
  right: 4px;
  filter: drop-shadow(0px 0px 2px white);
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    width: 44px;
    height: 44px;
    padding: 12px;
    top: 0px;
    right: 0px;
  }
`

export const DownloadIconContainer = styled(Icon)`
  position: absolute;
  bottom: 4px;
  left: 4px;
  filter: drop-shadow(0px 0px 2px white);
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    width: 44px;
    height: 44px;
    padding: 12px;
    top: 0px;
    right: 0px;
  }
`
export const LoginMessage = styled.div`
  font-size: 16px;
  line-height: 23px;
  margin-top: 16px;
  text-align: center;
`

export const CustomButton = styled.div`
  padding: 5px;
  border: 1px solid ${GRAY_DARK};
  border-radius: 4px;
  justify-content: center;
  width: 200px;
  margin-top: 22px;
  display: inline-flex;
  cursor: pointer;
  transition: background 0.4s ease, color 0.3s ease;
  &:hover {
    background: ${GRAY_DARK};
    color: ${WHITE};
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/AiTab/styledComponents.tsx